import { InjectionToken } from '@angular/core';
import { FirebaseApp } from 'firebase/app';
import { Auth } from 'firebase/auth';
import { Firestore } from 'firebase/firestore';
import { Messaging } from 'firebase/messaging';

/**
 * Direct-SDK replacement tokens for the DI classes previously provided by
 * @angular/fire (FirebaseApp, Auth, Firestore, Messaging).
 */
export const FIREBASE_APP = new InjectionToken<FirebaseApp>('FIREBASE_APP');
export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH');
export const FIREBASE_FIRESTORE = new InjectionToken<Firestore>(
  'FIREBASE_FIRESTORE'
);
export const FIREBASE_MESSAGING = new InjectionToken<Messaging>(
  'FIREBASE_MESSAGING'
);
